import React, { useEffect } from "react";
import WOW from "wowjs";
import "./Projects.css";
import "animate.css"; // Ensure animate.css is imported
export default function Projects() {
  useEffect(() => {
    new WOW.WOW().init();
  }, []);

  return (
    <section id="projects" className="projects-section">
      <div className="terminal-header">
        <div className="terminal-buttons">
          <span className="terminal-button close"></span>
          <span className="terminal-button minimize"></span>
          <span className="terminal-button zoom"></span>
        </div>
        <div className="terminal-title">projects.jsx</div>
      </div>

      <div className="terminal-content">
        <div className="code-line">
          <span className="line-number">01</span>
          {/* Technical Projects Implementation */}
        </div>

        <div className="project-container">
          <div className="project-card wow fadeInLeft" data-wow-delay="0.3s">
            <div className="project-info">
              <div className="code-line">
                <span className="line-number">02</span>
                <span className="const">const</span> <span className="project-name">PESUprep</span> = {"{"}
              </div>
              
              <h3>End to end Preparation, evaluation tool for PES Examinations</h3>
              <div className="tech-stack">
                <span className="tech-tag">MERN Stack</span>
                <span className="tech-tag">RAG</span>
                <span className="tech-tag">DistilGPT-2</span>
                <span className="tech-tag">Machine Learning</span>
              </div>

              <div className="implementation-details">
                <div className="code-line">
                  <span className="line-number">03</span>
                  <span className="code-keyword">implementation</span>: [
                </div>
                <ul>
                  <li>{"{"} Built ML-powered question generation platform with RAG and fine-tuned DistilGPT-2 </li>
                  <li>{"{"} Enabled dynamic test creation and adaptive learning paths </li>
                  <li>{"{"} Integrated AI-generated question banks with difficulty levels </li>
                  <li>{"{"} Implemented topic tagging for targeted assessment delivery </li>
                </ul>
                <div className="code-line">
                  <span className="line-number">04</span>
                  ]
                </div>
              </div>

              <div className="project-links">
                <a href="https://github.com/vm5/capstone" target="_blank" rel="noopener noreferrer">
                  <i className="fas fa-code"></i> Source
                </a>
              </div>
            </div>
          </div>

          <div className="project-card wow fadeInLeft" data-wow-delay="0.3s">
            <div className="project-info">
              <div className="code-line">
                <span className="line-number">05</span>
                <span className="const">const</span> <span className="project-name">Raftify</span> = {"{"}
              </div>
              
              <h3>Distributed 3D Printer Management System</h3>
              <div className="tech-stack">
                <span className="tech-tag">Go</span>
                <span className="tech-tag">Raft Consensus</span>
                <span className="tech-tag">RESTful APIs</span>
                <span className="tech-tag">Distributed Systems</span>
              </div>

              <div className="implementation-details">
                <div className="code-line">
                  <span className="line-number">06</span>
                  <span className="code-keyword">implementation</span>: [
                </div>
                <ul>
                  <li>{"{"} Engineered fault-tolerant system using Raft consensus algorithm </li>
                  <li>{"{"} Implemented automatic leader election and resilient cluster communication </li>
                  <li>{"{"} Designed RESTful APIs for printer and job management </li>
                  <li>{"{"} Ensured data consistency using persistent Raft logs </li>
                </ul>
                <div className="code-line">
                  <span className="line-number">07</span>
                  ]
                </div>
              </div>

              <div className="project-links">
                <a href="https://github.com/vm5/raftify" target="_blank" rel="noopener noreferrer">
                  <i className="fas fa-code"></i> Source
                </a>
              </div>
            </div>
          </div>

          <div className="project-card wow fadeInLeft" data-wow-delay="0.3s">
            <div className="project-info">
              <div className="code-line">
                <span className="line-number">08</span>
                <span className="const">const</span> <span className="project-name">ElKaf</span> = {"{"}
              </div>
              
              <h3>Distributed Logging System</h3>
              <div className="tech-stack">
                <span className="tech-tag">Kafka</span>
                <span className="tech-tag">Elasticsearch</span>
                <span className="tech-tag">Real-time Streaming</span>
                <span className="tech-tag">Distributed Systems</span>
              </div>

              <div className="implementation-details">
                <div className="code-line">
                  <span className="line-number">09</span>
                  <span className="code-keyword">implementation</span>: [
                </div>
                <ul>
                  <li>{"{"} Developed distributed logging system with Kafka streaming </li>
                  <li>{"{"} Implemented Elasticsearch for fast, reliable indexing </li>
                  <li>{"{"} Enabled real-time log processing and search capabilities </li>
                  <li>{"{"} Optimized system for high throughput and low latency </li>
                </ul>
                <div className="code-line">
                  <span className="line-number">10</span>
                  ]
                </div>
              </div>

              <div className="project-links">
                <a href="https://github.com/Cloud-Computing-Big-Data/EC-Team-8-distributed-logging-system" target="_blank" rel="noopener noreferrer">
                  <i className="fas fa-code"></i> Source
                </a>
              </div>
            </div>
          </div>

          <div className="project-card wow fadeInLeft" data-wow-delay="0.3s">
            <div className="project-info">
              <div className="code-line">
                <span className="line-number">11</span>
                <span className="const">const</span> <span className="project-name">Metabook</span> = {"{"}
              </div>
              
              <h3>Facebook Clone</h3>
              <div className="tech-stack">
                <span className="tech-tag">MERN Stack</span>
                <span className="tech-tag">JWT Auth</span>
                <span className="tech-tag">Real-time Updates</span>
                <span className="tech-tag">MongoDB</span>
              </div>

              <div className="implementation-details">
                <div className="code-line">
                  <span className="line-number">12</span>
                  <span className="code-keyword">implementation</span>: [
                </div>
                <ul>
                  <li>{"{"} Built full-stack social platform with MERN stack </li>
                  <li>{"{"} Implemented JWT authentication and user profiles </li>
                  <li>{"{"} Developed real-time post interactions and friend requests </li>
                  <li>{"{"} Designed modular and scalable architecture </li>
                </ul>
                <div className="code-line">
                  <span className="line-number">13</span>
                  ]
                </div>
              </div>
              

              <div className="project-links">
                <a href="https://github.com/vm5/metabook" target="_blank" rel="noopener noreferrer">
                  <i className="fas fa-code"></i> Source
                </a>
              </div>
            </div>
          </div>
        </div>
        
        <div className="code-line">
          <span className="line-number">14</span>
          <span className="const">const</span> <span className="project-name">rotBRAINrot</span> = {"{"}
        </div>
        <h3>Your Go to GenZ Therapist</h3>
              <div className="tech-stack">
                <span className="tech-tag">MERN Stack</span>
                <span className="tech-tag">Prompt engineering with DialoGPT (A Hugging Face model)</span>
                <span className="tech-tag">Google OAuth2</span>
              </div>
               <div className="implementation-details">
                <div className="code-line">
                  <span className="line-number">15</span>
                  <span className="code-keyword">implementation</span>: [
                </div>
                <ul>
                  <li>{"{"} Building a cyberpunk-themed mental health web app using React, Material-UI, and Hugging Face DialoGPT, featuring AI-driven therapy chat, customizable reminders, and a secure digital journal</li>
                  <li>{"{"} Integrated Emotion-based styling, Recharts for mood analytics, and real-time browser notifications, delivering a Gen Z-centric UX with animated chat bubbles and .exe-style modular architecture </li>
                </ul>
                <div className="code-line">
                  <span className="line-number">13</span>
                  ]
                </div>
              </div>
              <div className="project-links">
                <a href="https://github.com/vm5/rotbrainrot" target="_blank" rel="noopener noreferrer">
                  <i className="fas fa-code"></i> Source
                </a>
              </div>
      </div>    
    </section>
  );
}
